import { Tracking, View } from '../manager';
import '../globals';
import './reducer';
import React from 'react';
import Timeline from '../model/timeline';
import system from '../system';
import { IAppState } from 'vev';
import { pageKeyByPath } from '../utils/route';
import polyfills from './polyfills';
import { StateProvider } from './state';
import { App } from '../components';
import ReactDOM from 'react-dom';

export { Timeline };

export * from './state';
export * from './hooks';
export * from '../manager';
export * from '../components';
export * from '../utils';

export const h = React.createElement;
export const s = system;

function importAll(state: IAppState): Promise<any> {
  const imports = {};
  for (const { type } of state.models) imports[state.pkg[type] || type] = true;
  return Promise.all(Object.keys(imports).map((key) => system.import(key, true)));
}

export async function render(
  state: IAppState,
  root: HTMLElement = document.getElementById(state.project),
  doHydrate: boolean = true
) {
  if (!root) return console.error('Failed to render vev, missing root node');

  View.updateSize();
  await Promise.all([importAll(state), polyfills()]);

  // state.embed = root.hasAttribute('embed');
  if (!state.route) {
    // const pageKey = state.embed
    //   ? root.getAttribute('embed') || state.pages.find((p) => p.index).key
    //   : pageKeyByPath(location.pathname, state.pages, state.dir);
    state.route = { pageKey: pageKeyByPath(location.pathname, state.pages, state.dir) };
  }

  const jsx = (
    <StateProvider state={state}>
      <App />
    </StateProvider>
  );

  if (doHydrate) ReactDOM.hydrate(jsx, root);
  else ReactDOM.render(jsx, root);
}

declare const vevr: () => void;
declare const vevc: () => void;
// Check if pending vev widget register exits (window.vevr). Added by widget script if loaded before window.vev exists
if (typeof vevr !== 'undefined') setTimeout(vevr, 0);
// Check if pending vev content render exits (window.vevr). Added by content script if loaded before window.vev exists
if (typeof vevc !== 'undefined') setTimeout(vevc, 0);

export const Router = {};
